module.exports = __webpack_public_path__ + "img/about_img02.735e0bdc.png";